import type { IntlShape } from 'react-intl';

// Default copies; the translations live in Tolgee under pricingModel.pricingModels.<pricingModel>
const PRICING_MODEL_LABELS: Record<string, string> = {
  'd-cpm': 'D-CPM',
  'f-cpm': 'F-CPM',
  ppal: 'CPA',
  ppc: 'CPC',
  ppe: 'CPE',
  ppi: 'CPI',
  pppv: 'CPPV',
  ppsv: 'CPSV',
  ppv: 'CPV'
};

export function getPricingModelLabel(formatMessage: IntlShape['formatMessage'], pricingModel?: string): string {
  if (!pricingModel) {
    return '-';
  }
  return formatMessage({
    defaultMessage: PRICING_MODEL_LABELS[pricingModel] ?? pricingModel.toUpperCase(),
    id: `pricingModel.pricingModels.${pricingModel}`
  });
}
